<ngx-ui-loader></ngx-ui-loader>
<app-toast aria-live="polite" aria-atomic="true"></app-toast>
<router-outlet></router-outlet>